import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Map, Wrench, GraduationCap } from 'lucide-react';
import { PATHWAY_ROUTES } from '../lib/pathwayRoutes';

const CARDS = [
  { Icon: Map, number: '28 States', text: 'Explore government PLFS 2025 graduate and postgraduate unemployment figures, with clear sources and definitions.' },
  { Icon: Wrench, number: '65 Practical Roles', text: 'Explore blue-collar and agriculture skills, tools, hands-on activities and enterprise possibilities.' },
  { Icon: GraduationCap, number: '5 Education Stages', text: 'Schooling, Intermediate, B.Tech, BBA and MBA—with activities suited to each stage.' },
];

const RealityCheck = () => (
  <section className="py-20 md:py-24 px-4 md:px-6 text-white" style={{ background: '#0F172A' }} data-testid="reality-check-section">
    <div className="max-w-6xl mx-auto">
      <h2 className="text-3xl md:text-5xl font-bold leading-[1.15] tracking-tight max-w-4xl" data-testid="reality-check-headline">See the evidence. Build practical options.</h2>
      <p className="mt-4 text-base md:text-lg text-white/80 max-w-2xl" data-testid="reality-check-intro">Explore graduate unemployment in your state and practical learning connected to your education.</p>
      <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="reality-check-stats">
        {CARDS.map(({ Icon, number, text }, i) => (
          <div key={number} className="border-t border-white/15 pt-8 min-w-0" data-testid={`reality-check-stat-${i}`}>
            <Icon size={22} className="text-teal-300" aria-hidden />
            <p className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tight">{number}</p>
            <p className="mt-3 text-sm md:text-base text-white/75">{text}</p>
          </div>
        ))}
      </div>
      <p className="mt-10 text-sm text-white/60 max-w-2xl" data-testid="reality-check-closing">Build academic knowledge, practical capability and respect for every kind of work. These counts describe this learning catalogue — not vacancies, guaranteed jobs or government approval.</p>
      <Link to={PATHWAY_ROUTES['the-ai-shift']} className="mt-6 inline-flex items-center gap-2 rounded-full bg-teal-400 text-gray-950 font-bold px-6 py-3 hover:bg-teal-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white lxt-glow-cta" data-testid="reality-check-cta">Explore The AI Shift <ArrowRight size={16} /></Link>
    </div>
  </section>
);

export default RealityCheck;
